import {
  CREATE_SUGGESTED_COMPETITOR_REQUEST,
  CREATE_SUGGESTED_COMPETITOR_SUCCESS,
  CREATE_SUGGESTED_COMPETITOR_FAILURE,
} from "../actions/suggestedCompetitorActions";

const initialState = {
  creating: false,
  success: false,
  error: null,
};

export default function suggestedCompetitorReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case CREATE_SUGGESTED_COMPETITOR_REQUEST:
      return {
        ...state,
        creating: true,
        success: false,
        error: null,
      };

    case CREATE_SUGGESTED_COMPETITOR_SUCCESS:
      return {
        ...state,
        creating: false,
        success: true,
      };

    case CREATE_SUGGESTED_COMPETITOR_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
